import { render, staticRenderFns } from "./SanityBlockContent.vue?vue&type=template&id=e21f99c4&"
import script from "./SanityBlockContent.vue?vue&type=script&lang=ts&"
export * from "./SanityBlockContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports